export default __webpack_public_path__ + "static/media/LogoMV3.6f6b79c6.png";